<template>
  <div>
    <loading :active.sync="loading"
             :can-cancel="false"
             :is-full-page="true"></loading>

    <div v-if="!isOnline" class="offline-notification">
      <font-awesome-icon icon="fa-solid fa-wifi-slash" class="offline-icon"></font-awesome-icon>
      <span class="offline-text">You are offline - Only Cash transactions available</span>
    </div>

    <div class="method-sheet">
      <div class="header">
        <h4><b> Select Payment Methods </b></h4>
      </div>

      <div class="row">
        <div class="col">
          <div class="payment-method-btn">
            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="processTransaction('Cash')">
              <font-awesome-icon icon="fa-solid fa-money-bills"/>
              Cash
            </button>
          </div>
        </div>
        <div class="col">
          <div class="payment-method-btn">
            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="processTransaction('Card')">
              <font-awesome-icon icon="fa-solid fa-credit-card"/>
              Card
            </button>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col">
          <div class="payment-method-btn">
            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="goToSplitScreen">
              <font-awesome-icon icon="fa-solid fa-arrows-split-up-and-left"/>
              Split
            </button>
          </div>
        </div>
        <div class="col">
          <div class="payment-method-btn" v-if="!saleDetails.refund">
            <button class="lyt-soft-btn" :disabled="isAmountTooLow || !isOnline" @click="kazangPayment">
              <img height="25px" src="@/assets/img/Kazang.png" alt="Kazang">
              Kazang
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <!--        <div class="col-6">-->
        <!--          <div class="payment-method-btn" v-if="!saleDetails.refund">-->
        <!--            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="spennPayment">-->
        <!--              <img height="35px" src="@/assets/img/SpennLogo.png" alt="Spenn">-->
        <!--              Spenn-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="col-6" v-if="customer">
          <div class="payment-method-btn" >
            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="processTransaction('AccountSale')">
              <font-awesome-icon icon="fa-solid fa-address-card"/>
              Account
            </button>
          </div>
        </div>

        <div class="col-6" v-if="lodgeIntegrated && !saleDetails.refund">
          <div class="payment-method-btn">
            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="roomPayment">
              <font-awesome-icon icon="fa-solid fa-bed" />
              Room
            </button>
          </div>
        </div>

        <div class="col-6" v-if="isValidString(loyaltyDetails.barcode)">
          <div class="payment-method-btn" >
            <button class="lyt-soft-btn" :disabled="isAmountTooLow || !isOnline" @click="processTransaction('Loyalty Program')">
              <font-awesome-icon icon="heart-circle-check" style="height: 20px"/>
              Loyalty
            </button>
          </div>
        </div>
      </div>
      <line-separator title="Additional Methods" class="mb-1"/>
      <div class="row">
        <div class="col-6" v-for="method in paymentMethods">
          <div class="payment-method-btn">
            <ForeignCurrency :row-data="method" v-if="!method.IsBaseCurrency" @click="processTransaction(method.name)"/>
            <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="processTransaction(method.name)" v-else>
              {{ method.name }} ({{ method.CurrencySymbol }})
            </button>
          </div>
        </div>
      </div>


      <div class="payment-method-btn" v-if="!saleDetails.refund && deviceSettings.layby">
        <button class="lyt-soft-btn" :disabled="isAmountTooLow" @click="createLayBySales">
          <font-awesome-icon icon="truck" style="height: 20px"/>
          Sell on Lay-By
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ForeignCurrency from "@/components/point-of-sale/sales/payment/ForeignCurrency";
import LineSeparator from "@/components/layout/utils/LineSeparator.vue";
import connectivityMonitor from '@/services/connectivityMonitor';
import LodgingIntegration from "@/services/lodgingIntegration";

export default {
  name: "DesktopPaymentMethods",
  components: {LineSeparator, ForeignCurrency},
  props: {
    minimumAmount: {
      required: true
    },
    // setSwipe: {type: Function, required: true}
    // reference: { type: String, required: true },
    // total: { type: Number, required: true },
    // paid: { type: Number, required: true },
    // change: { type: Number, required: true },
  },
  computed: {
    currentSaleLines() {
      return this.$store.getters.getSaleLines
    },
    isAmountTooLow() {
      if (this.currentSaleLines.length === 0) return true;
      if (this.minimumAmount === "") return false;
      if(this.saleTotal > Number(this.minimumAmount)) {
        return this.saleTotal > Number(this.minimumAmount);
      }
      if(this.saleTotal === Number(this.minimumAmount)){
        return !(this.saleTotal === Number(this.minimumAmount));
      }
    },
    saleDetails() {
      return this.$store.getters.getSaleDetails
    },
    loyaltyDetails() {
      return this.$store.getters.getLoyaltyDetails;
    },
    customer() {
      let customer = this.$store.getters.getCustomer;

      return customer;
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal + this.$store.getters.getTipAmount
    },
    deviceSettings() {
      return this.$store.getters.getDeviceSettings;
    },
    discount() {
      return this.$store.getters.getSaleDiscount;
    },
    paymentMethods() {
      return this.$store.getters.getPaymentMethods
          .filter(method => method.active);
    }
  },
  data() {
    return {
      loading: false,
      isOnline: true,
      unsubscribeOnline: null,
      unsubscribeOffline: null,
      lodgeIntegrated: false
    }
  },


  async mounted() {

    this.lodgeIntegrated = await LodgingIntegration.isLodgeIntegrated();

    this.isOnline = connectivityMonitor.getStatus();

    // Subscribe to connectivity events
    this.unsubscribeOnline = connectivityMonitor.subscribe('online', () => {
      this.isOnline = true;
    });

    this.unsubscribeOffline = connectivityMonitor.subscribe('offline', () => {
      this.isOnline = false;
    });
  },
  beforeDestroy() {
    // Unsubscribe from connectivity events
    if (this.unsubscribeOnline) {
      this.unsubscribeOnline();
    }
    if (this.unsubscribeOffline) {
      this.unsubscribeOffline();
    }
  },
  methods: {
    createLayBySales() {
      return this.$router.push({name: `lay-by-payment`});
    },
    setPropertyValue(property, value) {
      this[property] = value;
    },
    isValidString(string) {
      return isValidString(string);
    },
    processTransaction(type) {
      this.$emit(`processPayment`,type);
    },
    async openCashDrawer() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `OpenDrwer`);
      if (isAllowed) return this.$store.dispatch(`openCashDrawer`)
    },
    goToSplitScreen() {
      const current = this.saleDetails || {};
      const updated = { ...current, type: 'Split' };
      this.$store.commit('setSaleDetails', updated);
      return this.$router.push({name: 'split-payment'})
    },

    kazangPayment() {
      // Set saleDetails with the correct sale total before initiating Kazang payment
      const current = this.saleDetails || {};
      const updated = {
        ...current,
        refund: false,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: 0,
        change: 0
      };
      this.$store.commit('setSaleDetails', updated);

      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          return this.$store.dispatch('firstKazangPaymentStep', input)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return result.value;
        }
      })
    },

    confirmKazangPayment(firstKazangStepResponse) {
      if (firstKazangStepResponse === "processed") {
        return firstKazangStepResponse;
      }
      return Swal.fire({
        title: 'Confirm Kazang Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondKazangStep', firstKazangStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return result.value;
        }
      })
    },

    spennPayment() {
      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          return this.$store.dispatch('firstSpennPaymentStep', input)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.confirmSpennPayment(result.value)
        }
      })
    },
    async roomPayment() {
// Set saleDetails with the correct sale total before initiating room payment
      const current = this.saleDetails || {};
      const updated = {
        ...current,
        refund: false,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: 0,
        change: 0
      };
      this.$store.commit('setSaleDetails', updated);

// Emit event to show room selection modal
      this.$emit('show-room-selection');
    },


    confirmSpennPayment(firstSpennStepResponse) {
      if (firstSpennStepResponse === "processed") {
        return firstSpennStepResponse;
      }
      return Swal.fire({
        title: 'Confirm Spenn Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondSpennStep', firstSpennStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return result.value;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.method-sheet {
  padding: 20px; /* Adjusted padding */
  font-family: var(--font-family); /* Consistent font family */
  color: var(--text-primary); /* Default text color */
}

h4 {
  display: flex;
  justify-content: center;
  color: var(--text-primary); /* Consistent text color */
  font-weight: 700;
  margin-bottom: 20px; /* Adjusted margin */
}

.lyt-soft-btn {
  color: white;
  font-size: 1.1rem; /* Slightly larger font */
  font-weight: 600; /* Consistent font weight */
  font-family: var(--font-family); /* Consistent font family */
  border-radius: 12px; /* Consistent border-radius */
  height: 65px; /* Consistent height */
  width: 100%; /* Adjusted width to fill column */
  background: linear-gradient(135deg, var(--accent-electric-blue), var(--accent-neon-purple)); /* Gradient background */
  border: none;
  box-shadow: var(--card-shadow); /* Consistent shadow */
  transition: var(--transition-speed); /* Consistent transition */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px; /* Space between icon/image and text */

  &:hover {
    background: linear-gradient(135deg, var(--accent-electric-blue-dark), var(--accent-neon-purple-dark)); /* Darker gradient on hover */
    transform: translateY(-2px); /* Lift effect on hover */
    box-shadow: var(--card-shadow-hover); /* Enhanced hover shadow */
  }

  &:active {
    transform: translateY(0); /* Press down effect */
  }

  img {
    height: 30px; /* Adjusted image height */
    width: auto;
  }

  .fa-solid,
  .heart-circle-check {
    font-size: 1.5rem; /* Consistent icon size */
    height: 25px; /* Ensure consistent height for icons */
    width: 25px;
  }

  &:disabled {
    opacity: 0.6; /* Dim disabled buttons */
    cursor: not-allowed;
    background: var(--disabled-button-bg); /* Use disabled background color */
    box-shadow: none;
    transform: none;
  }
}

.payment-method-btn {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px; /* Increased margin-bottom */
  height: auto; /* Let button height be determined by lyt-soft-btn */
}

.header {
  position: sticky;
  top: 0;
  background: var(--card-bg); /* Use card background variable */
  z-index: 1;
  padding: 15px; /* Adjusted padding */
  border-bottom: 1px solid var(--card-border); /* Add border for separation */
  margin-bottom: 20px; /* Add margin for separation */
}

// Specific adjustments for desktop layout
.row {
  margin-left: -10px; /* Adjust row negative margin if needed */
  margin-right: -10px;
}

.col {
  padding-left: 10px; /* Adjust column padding if needed */
  padding-right: 10px;
}

// Offline Notification Styles
.offline-notification {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: var(--warning);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  margin: 10px 0;
  font-weight: 600;
  font-size: 14px;
  box-shadow: var(--card-shadow);
  animation: slideDown 0.3s ease;

  .offline-icon {
    font-size: 18px;
  }

  .offline-text {
    text-align: center;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
